import React from 'react';
import FooterWrapper from './footer.style';

const Footer = () => (
  <FooterWrapper>
    <div style={{height: "50px"}}/>
    <div className={"border-line"}/>
    <div className={"shoe"}>
        <span>Copyright &copy; {new Date().getFullYear()}</span>
        <span id={"❤️"}>❤️</span>
        <span><a className={"transition-join"} href="/">maartenpoirot.com</a></span>
    </div>
  </FooterWrapper>
);

export default Footer;
